// Utils
import ModelMapperApi from '@utils/modelMapperApi.compose'

// Services
import AdminService from '@/services/admin'

// Models
import AccountManagerModel from '@/models/admin/accountManager'

export const accountManager = {
  namespaced: true,
  state: {
    accountManager: {}
  },
  mutations: {
    setAccountManager (state, accountManager) {
      state.accountManager = accountManager
    }
  },
  actions: {
    async getAccountManager ({commit, state, dispatch}) {
      let accountManagerData

      const getAccountManagerFunc = ModelMapperApi.get(
        ModelMapperApi.model(AccountManagerModel),
        pass => pass, // ModelMapperApi.mapper(AdminMapper.mapAccountManagerDataFromAPI),
        ModelMapperApi.service(AdminService.getAccountManagerData, AdminService)
      )
      try {
        accountManagerData = await getAccountManagerFunc()
      } catch (ex) {
      }
      commit('setAccountManager', accountManagerData)
    }
  },
  getters: {
    accountManager: state => state.accountManager
  }
}
